import * as React from 'react'
import PropTypes from 'prop-types'
import { Button, Tag, Modal, Input } from 'antd'
import { SendOutlined, CheckCircleOutlined, StopOutlined } from '@ant-design/icons'
import styles from './Component.css'

export default class _Footer_ extends React.PureComponent {

  static propTypes = {
    submitting: PropTypes.bool,
    ramsRecordStatus: PropTypes.string,
    isHsUser: PropTypes.bool,
    onClickCancel: PropTypes.func.isRequired,
    onClickSubmit: PropTypes.func.isRequired,
    onClickSendForApproval: PropTypes.func.isRequired,
    onClickApprove: PropTypes.func.isRequired,
    onClickExpire: PropTypes.func.isRequired,
  }

  static defaultProps = {
    submitting: null,
    ramsRecordStatus: null,
    isHsUser: false,
  }

  state = {
    sendingForApproval: false,
    approveModalVisible: false,
    approveComment: '',
    approving: false,
  }

  handleSendForApproval = async () => {
    this.setState({ sendingForApproval: true })
    await this.props.onClickSendForApproval()
    this.setState({ sendingForApproval: false })
  }

  handleOpenApproveModal = () => {
    this.setState({ approveModalVisible: true, approveComment: '' })
  }

  handleCloseApproveModal = () => {
    this.setState({ approveModalVisible: false, approveComment: '' })
  }

  handleApprove = async () => {
    if (!this.state.approveComment.trim()) return
    this.setState({ approving: true })
    await this.props.onClickApprove(this.state.approveComment.trim())
    this.setState({ approving: false, approveModalVisible: false, approveComment: '' })
  }

  render () {

    const {
      submitting,
      ramsRecordStatus,
      isHsUser,
      onClickCancel,
      onClickSubmit,
      onClickExpire,
    } = this.props

    const { sendingForApproval, approveModalVisible, approveComment, approving } = this.state

    const canApprove = isHsUser && ramsRecordStatus === 'awaiting_approval'
    const canExpire = ramsRecordStatus && ramsRecordStatus !== 'expired'

    return (
        
      <div className={styles.footer}>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          {ramsRecordStatus === 'awaiting_approval' && <Tag color="processing">Awaiting Approval</Tag>}
          {ramsRecordStatus === 'approved' && <Tag color="success">Approved</Tag>}
          {ramsRecordStatus === 'expired' && <Tag color="error">Expired</Tag>}

          {ramsRecordStatus === 'unapproved' && (
            <Button
              type="default"
              loading={sendingForApproval}
              disabled={submitting}
              onClick={this.handleSendForApproval}
              icon={<SendOutlined />}
            >
              Send for Approval
            </Button>
          )}

          {canApprove && (
            <Button
              type="primary"
              onClick={this.handleOpenApproveModal}
              icon={<CheckCircleOutlined />}
              disabled={submitting}
              style={{ backgroundColor: '#52c41a', borderColor: '#52c41a' }}
            >
              Approve
            </Button>
          )}

          {canExpire && (
            <Button
              danger
              disabled={submitting || sendingForApproval || approving}
              onClick={onClickExpire}
              icon={<StopOutlined />}
            >
              Expire RAMS
            </Button>
          )}
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Button
            type="default"
            disabled={submitting || sendingForApproval || approving}
            onClick={onClickCancel}
            style={{ width: 80 }}
          >
            Cancel
          </Button>

          <Button
            type="primary"
            loading={submitting}
            disabled={sendingForApproval || approving}
            onClick={onClickSubmit}
            style={{ width: 80 }}
          >
            Save
          </Button>
        </div>

        <Modal
          title="Approve RAMS Record"
          visible={approveModalVisible}
          onCancel={this.handleCloseApproveModal}
          onOk={this.handleApprove}
          okText="Approve"
          okButtonProps={{ disabled: !approveComment.trim(), loading: approving }}
          cancelButtonProps={{ disabled: approving }}
        >
          <p>Please enter a comment for the approval:</p>
          <Input.TextArea
            rows={4}
            value={approveComment}
            onChange={(e) => this.setState({ approveComment: e.target.value })}
            placeholder="Enter your approval comment..."
            maxLength={2000}
          />
        </Modal>

      </div>

    )
  }
}